export type MedicalSpecialty =
    | 'allgemeinmedizin'
    | 'innere_medizin'
    | 'kardiologie'
    | 'onkologie'
    | 'orthopaedie'
    | 'neurologie'
    | 'dermatologie'
    | 'gastroenterologie'
    | 'pneumologie'
    | 'hno'
    | 'urologie'
    | 'gynaekologie'
    | 'augenheilkunde'
    | 'psychiatrie'
    | 'radiologie'
    | 'chirurgie'
    | 'anaesthesiologie'
    | 'paediatrie'
    | 'rheumatologie'
    | 'endokrinologie'
    | 'nephrologie'
    | 'haematologie'
    | 'geriatrie'
    | 'pathologie'
    | 'nuklearmedizin'
    | 'other';

export const SPECIALTY_LABELS: Record<MedicalSpecialty, string> = {
    allgemeinmedizin: 'Allgemeinmedizin',
    innere_medizin: 'Innere Medizin',
    kardiologie: 'Kardiologie',
    onkologie: 'Onkologie',
    orthopaedie: 'Orthopädie',
    neurologie: 'Neurologie',
    dermatologie: 'Dermatologie',
    gastroenterologie: 'Gastroenterologie',
    pneumologie: 'Pneumologie',
    hno: 'HNO',
    urologie: 'Urologie',
    gynaekologie: 'Gynäkologie',
    augenheilkunde: 'Augenheilkunde',
    psychiatrie: 'Psychiatrie',
    radiologie: 'Radiologie',
    chirurgie: 'Chirurgie',
    anaesthesiologie: 'Anästhesiologie',
    paediatrie: 'Pädiatrie',
    rheumatologie: 'Rheumatologie',
    endokrinologie: 'Endokrinologie',
    nephrologie: 'Nephrologie',
    haematologie: 'Hämatologie',
    geriatrie: 'Geriatrie',
    pathologie: 'Pathologie',
    nuklearmedizin: 'Nuklearmedizin',
    other: 'Sonstige',
};